//#region SITES
export function getTotalSiteRowAmount(kids, adults, perKid, perAdult, _9AdultsFee, _10AdultsFee) {
    const kidsTotal = Number.parseFloat(kids) * Number.parseFloat(perKid);
    let adultsTotal = 0;

    if(adults === 9 && Number.parseFloat(_9AdultsFee) > 0){
        adultsTotal = Number.parseFloat(_9AdultsFee);
    }
    else if(adults === 10 && Number.parseFloat(_10AdultsFee) > 0){
        adultsTotal = Number.parseFloat(_10AdultsFee);
    }
    else{
        adultsTotal = Number.parseFloat(adults) * Number.parseFloat(perAdult);
    }

    return kidsTotal + adultsTotal;
}

export function getTotalAmountSiteRowBreakDown(kids, adults, perKid, perAdult, _9AdultsFee, _10AdultsFee) {
    let breakdown = "(";

    if(kids > 0){
        breakdown += `$${perKid} x ${kids}`
    }
    else{
        breakdown += "$0";
    }

    breakdown += " + ";

    if(adults === 9 && Number.parseFloat(_9AdultsFee) > 0){
        breakdown += `$${_9AdultsFee}`
    }
    else if(adults === 10 && Number.parseFloat(_10AdultsFee) > 0){
        breakdown += `$${_10AdultsFee}`
    }
    else if(adults > 0){
        breakdown += `$${perAdult} x ${adults}`
    }
    else{
        breakdown += "$0";
    }

    breakdown += ")";

    return breakdown;
}

export function getTotalSitesFee(list, kids, adults) {
    let total = 0;

    for(let i = 0; i < list.length; i++){
        total += getTotalSiteRowAmount(kids, adults, list[i].kidsAge612Fee, list[i].adultFees['1'], list[i].adultFees['9'], list[i].adultFees['10']);
    }

    return total;
}
//#endregion

//#region ACTIVITIES
export function getTotalActivityRowAmount(kids, adults, chargesDetails) {
    const kidsTotal = Number.parseFloat(kids) * Number.parseFloat(chargesDetails?.kidsAge612Fee);

    let adultsTotal = 0;
    
    if(Number.parseFloat(adults) > 10){
        adultsTotal = Number.parseFloat(adults) * Number.parseFloat(chargesDetails?.adultFees['1']);
    }
    else{
        adultsTotal = Number.parseFloat(chargesDetails?.adultFees[adults]);
    }
    
    return kidsTotal + adultsTotal;
}

export function getTotalAmountActivityRowBreakDown(kids, adults, chargesDetails) {
    let breakdown = "(";

    if(kids > 0){
        breakdown += `$${chargesDetails?.kidsAge612Fee} x ${kids}`
    }
    else{
        breakdown += "$0";
    }

    breakdown += " + ";

    if(Number.parseFloat(adults) > 10){
        breakdown += `$${chargesDetails?.adultFees['1']} x ${adults}`
    }
    else if(Number.parseFloat(adults) > 0){
        breakdown += `$${chargesDetails?.adultFees[adults]}`;
    }
    else{
        breakdown += "$0";
    }

    breakdown += ")";

    return breakdown;
}

export function getTotalActivitiesFee(list, kids, adults) {
    let total = 0;

    for(let i = 0; i < list.length; i++){
        total += getTotalActivityRowAmount(kids, adults, list[i]);
    }

    return total;
}
//#endregion

export function getTotalFee(siteList, activitiesList, kids, adults) {
    let total = getTotalSitesFee(siteList, kids, adults);
    total += getTotalActivitiesFee(activitiesList, kids, adults);

    return total;
}